module.exports = __webpack_public_path__ + "img/madiran.ed752c4.png";